import { render, staticRenderFns } from "./UnclosedDealList.vue?vue&type=template&id=6ca9c965&"
import script from "./UnclosedDealList.vue?vue&type=script&lang=js&"
export * from "./UnclosedDealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports